const dateComparator = (date1, date2) => {
	var date1Number = monthToComparableNumber(date1);
	var date2Number = monthToComparableNumber(date2);
	if (date1Number === null && date2Number === null) {
		return 0;
	}
	if (date1Number === null) {
		return -1;
	}
	if (date2Number === null) {
		return 1;
	}
	return date2Number - date1Number;
};

const monthToComparableNumber = (date) => {
	if (date === undefined || date === null) {
		return null;
	}
	var minute = date.substring(14, 16);
	var hour = date.substring(11, 13);
	var yearNumber = date.substring(6, 10);
	var monthNumber = date.substring(3, 5);
	var dayNumber = date.substring(0, 2);
	var cellDate = new Date(
		Number(yearNumber),
		Number(monthNumber) - 1,
		Number(dayNumber),
		Number(hour),
		Number(minute),
	);

	return cellDate.getTime();
}
export default dateComparator;
